"use strict";

module.exports = function () {
    $('.copy-invitation-link').on('click', function(e) {
        e.preventDefault();
        let $this = $(this);
        navigator.clipboard.writeText($(this).data('url'));
        let oldText = $this.html();
        $(this).html($this.data('copied-text'));
        setTimeout(function(){
            $this.html(oldText);
        }, 3000)
    });
}
